import React from 'react';

export default function SvgVolume() {
  return (
    <svg
      width="25"
      height="21"
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.974 20.8399C11.0822 20.943 11.2257 21 11.375 21H15.4583C15.7808 21 16.0417 20.7391 16.0417 20.4167V0.583333C16.0417 0.26119 15.7808 0 15.4583 0H11.375C11.2257 0 11.0822 0.057251 10.974 0.15979L5.60091 5.25H0.583334C0.260904 5.25 0 5.51119 0 5.83333V15.1667C0 15.4888 0.260904 15.75 0.583334 15.75H5.60091L10.974 20.8399ZM6.19862 6.75H1.5V14.25H6.19859L11.7406 19.5H14.5417V1.5H11.7403L6.19862 6.75Z"
        fill="#828282"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6825 3.54524C21.4438 3.33133 21.0741 3.35098 20.8587 3.59081C20.6441 3.83076 20.6644 4.19927 20.9038 4.4141C21.0743 4.56673 21.2382 4.72636 21.3941 4.89148C22.8192 6.40078 23.625 8.40906 23.625 10.5C23.625 12.5919 22.819 14.6007 21.3927 16.1101C21.3596 16.1452 21.3261 16.18 21.2922 16.2146C21.1674 16.342 21.0381 16.4658 20.9043 16.5855L20.9034 16.5863C20.6636 16.8011 20.6428 17.1701 20.8576 17.4102C20.9727 17.539 21.1322 17.6045 21.2922 17.6045C21.4306 17.6045 21.5695 17.5556 21.6811 17.456C21.8632 17.2931 22.0386 17.1233 22.2061 16.9478C23.8574 15.219 24.7917 12.9076 24.7917 10.5C24.7917 8.0934 23.8579 5.78239 22.2072 4.05342C22.0397 3.87791 21.8646 3.70825 21.6825 3.54524Z"
        fill="#828282"
      />
      <path
        d="M18.5243 6.19851C18.7396 5.9584 19.1093 5.93903 19.348 6.15291L19.3488 6.15359C19.5349 6.32028 19.7091 6.49784 19.8706 6.68489C20.7808 7.73858 21.2917 9.09322 21.2917 10.5C21.2917 11.9074 20.7808 13.2624 19.8701 14.316C19.7083 14.5032 19.534 14.6808 19.3476 14.8475C19.236 14.9471 19.0967 14.9964 18.9584 14.9964C18.7983 14.9964 18.6388 14.9309 18.5237 14.8021C18.309 14.562 18.3295 14.1931 18.5693 13.9784L18.5704 13.9774C18.7081 13.8542 18.8375 13.7235 18.9584 13.5864C18.9837 13.5577 19.0086 13.5287 19.0331 13.4995C19.7334 12.6643 20.1251 11.6022 20.1251 10.5C20.1251 9.39848 19.7335 8.33668 19.0338 7.50156C18.8916 7.33191 18.7368 7.17161 18.5699 7.02224C18.3305 6.80713 18.3097 6.43846 18.5243 6.19851Z"
        fill="#828282"
      />
    </svg>
  );
}
